import React from "react";
import { RadarData, RadarOptions } from "./ChartConfigure";
import { Radar } from "react-chartjs-2";

export default class RadarChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    console.log(this.chartRef);
  }

  render() {
    const filteredRadarData = {
      ...RadarData,
      datasets: RadarData.datasets.filter(
        (ds) => this.props.selectedData.indexOf(ds.label) > -1
      ),
    };
    return (
      <Radar
        ref={this.chartRef}
        data={filteredRadarData}
        options={RadarOptions}
      />
    );
  }
}
